import type { PropsWithChildren, ReactNode } from "react";
import { tv } from "tailwind-variants";

const statTileVariants = tv({
  slots: {
    root: "rounded-lg border border-line px-4 py-3",
    label: "text-xs font-semibold tracking-wider text-content-muted uppercase",
    value: "mt-1 text-2xl font-semibold text-content-strong tabular-nums",
    detail: "block text-xs font-normal text-content-muted",
  },
  variants: {
    isWarning: {
      true: { value: "text-danger-content" },
    },
  },
});

type StatTileProps = {
  label: ReactNode;
  detail?: ReactNode;
  isWarning?: boolean;
};

export const StatTile = ({
  children,
  detail,
  isWarning = false,
  label,
}: PropsWithChildren<StatTileProps>) => {
  const { detail: detailClass, label: labelClass, root, value } = statTileVariants({ isWarning });

  return (
    <div className={root()}>
      <dt className={labelClass()}>{label}</dt>

      <dd className={value()}>
        {children}

        {detail ? <small className={detailClass()}>{detail}</small> : null}
      </dd>
    </div>
  );
};
